const uploadAbortControllers = new Map();

export const registerUploadAbortController = (fileId, controller) => {
  uploadAbortControllers.set(fileId, controller);
};

export const unregisterUploadAbortController = (fileId) => {
  uploadAbortControllers.delete(fileId);
};

export const abortUploadById = (fileId) => {
  const uploadController = uploadAbortControllers.get(fileId);

  if (!uploadController) {
    return;
  }

  uploadController.abort();
  unregisterUploadAbortController(fileId);
};

export const abortAllUploads = () => {
  uploadAbortControllers.forEach((uploadController) => {
    uploadController.abort();
  });
  uploadAbortControllers.clear();
};
